import React from 'react'
import { connect } from 'react-redux'
import SchedulerActions from '../../Redux/SchedulerRedux'
import DateTime from 'react-datetime'
import { isObject } from 'lodash'
import moment from 'moment'

class CreateScheduler extends React.Component {
  constructor (props) {
    super(props)
    this.productType = [
      { label: 'Wifi Products', value: 'modems' },
      // { label: 'Attractions', value: 'attractions' },
      { label: 'Banners', value: 'banners' }
    ]
    this.state = {
      form: {
        product: '',
        date: null,
        title: '',
        items: []
      }
    }
  }

  _handleDateTimeChange = (event, field) => {
    let value
    switch (field) {
      case 'product':
      case 'title':
        value = event.target.value
        break
      case 'date':
        if (isObject(event)) {
          value = event
        }
        break
      default:
        return null
    }
    let form = { ...this.state.form }
    form[field] = value
    this.setState({ form })
  }

  _submit = (event) => {
    event && event.preventDefault()
    let data = { ...this.state.form }
    this.props.postScheduler(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 500)
  }

  render () {
    const { scheduler } = this.props
    return (
      <section className='section' style={{ width: '50vw', height: '70vh' }}>
        <header className='title-block'>
          <h1 className='title'>Create Scheduler</h1>
        </header>
        { scheduler.err && <div className='alert alert-danger'>{scheduler.err}</div> }
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Title</label>
            </div>
            <div className='col-9'>
              <input required placeholder='Insert Title ...' className='form-control' onChange={(e) => this._handleDateTimeChange(e, 'title')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Product Type</label>
            </div>
            <div className='col-9'>
              <select defaultValue='' required className='form-control' onChange={(e) => this._handleDateTimeChange(e, 'product')}>
                <option value='' disabled>-Select Product Type-</option>
                {
                  this.productType.map((option, i) => (
                    <option key={i} value={option.value}>{option.label}</option>
                  ))
                }
              </select>
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Date / Time</label>
            </div>
            <div className='col-9'>
              <DateTime
                inputProps={{ required: true }}
                isValidDate={(current) => current.isAfter(moment())}
                onChange={(date) => this._handleDateTimeChange(date, 'date')}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>
                <i className='fa fa-times' /> Close
              </button>
              <button type='submit' className='btn btn-primary'>
                <i className='fa fa-plus' /> Create
              </button>
            </div>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  scheduler: state.scheduler
})

const dispatchToProps = (dispatch) => ({
  postScheduler: (data) => dispatch(SchedulerActions.postSchedulerRequest(data))
})

export default connect(stateToProps, dispatchToProps)(CreateScheduler)



// WEBPACK FOOTER //
// ./src/Containers/Scheduler/CreateScheduler.js